import styled from "@emotion/styled";
import { PRIMARY_BLACK } from "src/constants/colors";

export const SubmitSuccessContainer = styled.div`
  border-top: 1px solid rgba(210, 213, 219, 1);
  color: rgba(74, 84, 102, 1);
  display: flex;
  flex-direction: column;
  font-size: 12px;
  padding-top: 40px;
  gap: 35px;

  & a {
    cursor: pointer;
    text-decoration: underline;
  }
`;

export const EmailClientRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 56px;
`;

export const EmailClientItemContainer = styled.a`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  text-decoration: none !important;
`;

export const EmailClientItemImage = styled.div`
  display: flex;
  align-items: center;
  height: 24px;
  width: 24px;
`;

export const EmailClientItemText = styled.div`
  color: ${PRIMARY_BLACK};
  font-size: 16px;
  font-weight: 400;
`;
